export default __webpack_public_path__ + "static/media/S3.5fd5faf9.svg";